// extracted by mini-css-extract-plugin
var _1 = "CarouselSlider-module__container--EzBWa";
var _2 = "CarouselSlider-module__dragInterceptor--s7tK7";
var _3 = "CarouselSlider-module__item--xOIj9";
var _4 = "CarouselSlider-module__slider--Ubo_7";
export { _1 as "container", _2 as "dragInterceptor", _3 as "item", _4 as "slider" }
